import { InjectionToken } from '@angular/core';

/** Interface for the parent list, used to break the circular dependency. */
export interface ICeListComponent {
    size?: string;
    selectedItems?: string[];
}

/**
 * Injection token used by `CeListItemComponent` to access its parent list
 * without creating a circular module dependency.
 */
export const CE_LIST_COMPONENT = new InjectionToken<ICeListComponent>('CeListComponent');
